import React from "react";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import { ReserveFormParkingList } from "@/features/reserve/components/Reserve/controls/ResereFormParkingList";

export interface ReserveFormParkingProps {
  className?: string;
}

export const ReserveFormParking: React.FC<ReserveFormParkingProps> = ({
  className
}) => {
  const { allowParking } = useReserveForm();
  if (!allowParking) return null;

  return (
    <div className={className}>
      <ReserveFormParkingList />
    </div>
  );
};
